import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  employee_request: {
    type: undefined, // required, enum(DAY_OFF, GO_LATE, COME_BACK_SOON, WORK_EXPLANATION, GO_OUT, GO_ON_BUSSINESS) Loại yêu cầu xin nghỉ làm, đi muộn, về sớm, giải trình công, ra ngoài, công tác
    employee_id: undefined, // required Mã nhân viên
    company_id: undefined, // required, ref: company - Công ty Id
    title: undefined, // required Tiêu đề
    content: undefined, // required Nội dung yêu cầu
    status: undefined, // required, enum(WAITING_FOR_APPROVAL, APPROVED, REJECTED) Trạng thái yêu cầu yêu cầu - WAITING_FOR_APPROVAL, duyệt - APPROVED, từ chối - REJECTED
    is_sequential: undefined, // required Có tuần tự hay không
    approval_level: undefined, // required Cấp độ duyệt
    approval_users: undefined, // optional Danh sách người duyệt
    approval_user_id: undefined, // required Người duyệt
    approval_at: undefined, // optional Thời điểm duyệt/từ chối
    is_approval: undefined, // optional Duyệt/Từ chối
    level1Approval: undefined,
    level2Approval: undefined,
    employeeApproval: undefined
  },
  detail_request: {
    shift_id: undefined,
    request_reason_id: undefined, // required Mã lý do
    extra_minute: undefined, // required Số phút về sớm
    type: undefined, // required, enum(LEAVE_WITH_PAY, LEAVE_WITHOUT_PAY) Loại nghỉ có lương và không lương
    start_date: undefined, // required Ngày bắt đầu công tác
    end_date: undefined, // required Ngày kết thúc công tác
    from_date: undefined, // required Từ thời điểm
    to_date: undefined, // required Tới thời điểm
    explained_start_date: undefined, // required, lt: $now Ngày bổ sung công từ
    explained_end_date: undefined, // required, lt: $now Ngày bổ sung công đến
    time_work: undefined,
    number_of_works: null,
    convert_work_method: undefined, // required, enum(AUTO, INPUT) - Phương pháp tính ra công
    dayoff_time: undefined, // optional Thời gian nghỉ
    date: undefined, // required Ngày chấm công
    ot_hours: null, // optional - Số phút OT
    work_value: null, // optional - Giá trị công
    reason_change: null, // optional - Lý do thay đổi
  }
};

// validation form
model.validForm = {
  employee_request: {
    employee_id: [ValidService.requiredChange],
    type: [ValidService.requiredChange], // required, enum(DAY_OFF, GO_LATE, COME_BACK_SOON, WORK_EXPLANATION, GO_OUT, GO_ON_BUSSINESS) Loại yêu cầu xin nghỉ làm, đi muộn, về sớm, giải trình công, ra ngoài, công tác
    title: [ValidService.required, ValidService.checkSpaceString], // required Tiêu đề
    content: [ValidService.required, ValidService.checkSpaceString], // required Nội dung yêu cầu
    status: [ValidService.required], // required, enum(WAITING_FOR_APPROVAL, APPROVED, REJECTED) Trạng thái yêu cầu yêu cầu - WAITING_FOR_APPROVAL, duyệt - APPROVED, từ chối - REJECTED
    is_sequential: [ValidService.required], // required Có tuần tự hay không
    approval_level: [ValidService.required],
    level1Approval: [],
    level2Approval: [ValidService.requiredChange],
    employeeApproval: [ValidService.requiredChange]
  },
  detail_request: {
    shift_id: [ValidService.requiredChange],
    request_reason_id: [ValidService.required, ValidService.requiredChange], // required Mã lý do
    extra_minute: [ValidService.required], // required Số phút về sớm
    type: [ValidService.requiredChange],
    start_date: [ValidService.required], // required Ngày bắt đầu công tác
    end_date: [ValidService.required], // required Ngày kết thúc công tác // required, enum(LEAVE_WITH_PAY, LEAVE_WITHOUT_PAY) Loại nghỉ có lương và không lương
    from_date: [ValidService.required], // required Từ thời điểm
    to_date: [ValidService.required], // required Tới thời điểm
    explained_start_date: [ValidService.required], // required, lt: $now Ngày bổ sung công
    explained_end_date: [ValidService.required], // required, lt: $now Ngày bổ sung công
    time_work: [ValidService.required],
    number_of_works: [ValidService.required, ValidService.checkNumberFloatNotNegative, ValidService.checkSpaceStringCenter],
    convert_work_method: [ValidService.requiredChange],
    date: [ValidService.required], // required Ngày chấm công
    ot_hours: [ValidService.required, ValidService.checkNumberFloatNotNegative, ValidService.checkSpaceStringCenter, ValidService.checkMaxLength(4)],
    work_value: [ValidService.required, ValidService.checkNumberFloatNotNegative, ValidService.checkSpaceStringCenter, ValidService.checkMaxLength(5)]
  }
};

// dữ liệu mẫu các form khác
model.dataFormRejectRequest = {
  note: null,
};

// validation các form khác
model.validFormRejectRequest = {
  note: [ValidService.required, ValidService.checkSpaceString],
};

// dữ liệu mẫu các form khác
model.dataFormCancelRequest = {
  note: null,
};

// validation các form khác
model.validFormCancelRequest = {
  note: [ValidService.required, ValidService.checkSpaceString],
};

model.listPhanLoai = [
  {
    value: "paid-leave",
    label: "Nghỉ có lương"
  },
  {
    value: "public-explanation",
    label: "Giải trình công"
  },
  {
    value: "late",
    label: "Đi muộn"
  },
  {
    value: "come-back-soon",
    label: "Về sớm"
  },
  {
    value: "go-out",
    label: "Ra ngoài"
  },
  {
    value: "business-travel",
    label: "Đi công tác"
  }
];

model.listCapDuyet = [
  {
    value: "1",
    label: "Cấp duyệt 1"
  },
  {
    value: "2",
    label: "Cấp duyệt 2"
  },
  {
    value: "3",
    label: "Cấp duyệt 3"
  }
];

model.listTrangThai = [
  {
    value: '',
    label: "Tất cả trạng thái",
    name: "ALL",
  },
  {
    value: "APPROVED",
    label: "Đã duyệt",
    name: "APPROVED",
  },
  {
    value: "REJECTED",
    label: "Từ chối",
    name: "REJECTED",
  },
  {
    value: "WAITING_FOR_APPROVAL",
    label: "Đang chờ duyệt",
    name: "WAITING_FOR_APPROVAL",
  },
]

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-created_at",
  defaultSort: ["created_at", "ascending"],
  filters: '',
  recordSelected: [],
  dataSearch: {
    value: {
      start_time: '',
      end_time: '',
      type: '',
      status: ''
      // created_at: ''
    },
    valid: {
      start_time: [],
      end_time: [],
      type: [],
      status: []
      // created_at: []
    },
    operator: {
      start_time: ":in_that_day:",
      end_time: ":in_that_day:",
      type: '',
      status: ''
      // created_at: ":in_that_day:"
    }
  }
};

model.tableRulePersonal = {
  lengthMenu: [20, 40, 80, 120, 200, 500],
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "-created_at",
  defaultSort: ['', ''],
  filters: '',
  recordSelected: [],
  dataSearch: {
    value: {},
    operator: {}
  }
}

export default model;
